import React, { lazy, useEffect } from 'react'
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { themeChange } from 'theme-change'
import checkAuth from './app/auth';
import initializeApp from './app/init';
import stomio from "@stomio/stomio-web-sdk"

const PROJECT_TOKEN = 'c86db460-c18f-4811-b864-8df33bf8739a'
localStorage.setItem('emailId', 'ibrahim+beta-demo@stomio.io')
// Public demo: no login wall — seed a token so every visitor is treated as authenticated
localStorage.setItem('token', 'DumyTokenHere')

async function initStomio() {
  const response = await fetch('https://us-central1-stomio-development.cloudfunctions.net/widget-demo-client-api?email=' + encodeURIComponent(localStorage.getItem("emailId")))
  const userSecurityToken = await response.text()
  await stomio.init({
    project: PROJECT_TOKEN,
    user: userSecurityToken
  })

  stomio.createWidget()
}

// Importing pages
const Layout = lazy(() => import('./containers/Layout'))
const Documentation = lazy(() => import('./pages/Documentation'))



// Initializing different libraries
initializeApp()


// Check for login and initialize axios
const token = checkAuth()


function App() {

  useEffect(() => {
    // 👆 daisy UI themes initialization
    themeChange(false)

  }, [])

  if (localStorage.getItem("emailId")) {
    initStomio()
  }

  return (
    <>
      <Router>
        <Routes>
          {/* Login disabled for public demo — send auth routes straight to the dashboard */}
          <Route path="/login" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="/forgot-password" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="/register" element={<Navigate to="/app/dashboard" replace />} />
          <Route path="/documentation" element={<Documentation />} />

          {/* Place new routes over this */}
          <Route path="/app/*" element={<Layout />} />

          <Route path="*" element={<Navigate to={token ? "/app/dashboard" : "/login"} replace />} />

        </Routes>
      </Router>
    </>
  )
}

export default App
